import { useEffect, useState } from 'react';

import { subscribeDoc, billingStateRef } from '@/lib/firestore';
import type { BillingState } from '@/schemas';

export type BillingStateWithId = BillingState & { id: string };

/** Live Stripe billing state for an account (null until any billing has
 * happened — i.e. before the first checkout). */
export function useBillingState(aid: string | null): {
  billing: BillingStateWithId | null;
  loading: boolean;
} {
  const [state, setState] = useState<{ loadedAid: string | null; data: BillingStateWithId | null }>({
    loadedAid: null,
    data: null,
  });
  useEffect(() => {
    if (!aid) {
      setState({ loadedAid: null, data: null });
      return;
    }
    setState({ loadedAid: null, data: null });
    const unsub = subscribeDoc<BillingState>(billingStateRef(aid), (data) => {
      setState({ loadedAid: aid, data: data as BillingStateWithId | null });
    });
    return unsub;
  }, [aid]);
  return {
    billing: state.loadedAid === aid ? state.data : null,
    loading: aid != null && state.loadedAid !== aid,
  };
}
